<template
  ><!-- 预售  抽奖 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStep != 0 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 0">
        <!-- <div class="tishi"> -->
        <div class="card-point tipBg">
          <div class="card-rule" style="width: 45px;">注：</div>
          <template v-if="venderType">
            <div class="card-connet" v-if="orderCRM">
              <p>
                1、自营店铺需要搭配<span style="color:#7B61FF;">云短信CRM</span
                >使用,<span
                  style="color:#7B61FF;"
                  @click="handleCreate"
                  class="pointer"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
            <div class="card-connet" v-else>
              <p>
                1、云短信CRM：订购到期时间
                {{ orderCRMtime }}（自营店铺需要搭配<span
                  @click="handleCreate"
                  class="pointer"
                  style="color:#7B61FF;"
                  >云短信CRM</span
                >使用）。
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
          </template>
          <div class="card-connet" v-else>
            <p>1、订单完成后发放奖励。</p>
          </div>
        </div>

        <!-- 导航切换 -->
        <!-- <div class="navTab">
        <span
          v-show="item.frontHide == 0"
          v-for="(item, index) in navList"
          :key="item.id"
          class="tab"
          :class="{ active: tabActive == index }"
          @click="handleNav(item, index)"
          >{{ item.groupName }}</span
        >
      </div> -->

        <!-- <div v-loading="loading" class="itemList">
        <div class="item">
          <template>
            <div class="wrapper-kaika">
              <div @click="handleOpen()" class="wrapper-kaika-img">
                <div class="borderkaika" style="width: 100%;height: 100%;top:0;left:0;"></div>
                <div style="margin-top: 155px;">
                  <img src="../../assets/images/integralCenter/dingzhi.png" alt="" />
                  <div>品牌定制</div>
                </div>
              </div>
              <div class="wrapper-kaika-img wrapperBg" v-for="item in giftList" :key="item.id">
                <div class="borderkaika"></div>
                <div class="wrapper-kaika-tanchuang" style="overflow: hidden; width: 206px;height: 346px;">
                  <img style="width:210px;height:auto" :src="item.imageUrl" alt="" />
                </div>
                <div v-if="item.activityStartTime" style="position: absolute;bottom: -10px;width: 100%;color: red;font-size: 12px;">
                  <span style="left: 10px;position: absolute;font-weight: 500;">限免</span>
                  <span style="right: 10px;position: absolute;font-weight: 500;">倒计时：{{ item.days }}</span>
                </div>
                <div class="mask">
                  <div class="img">
                    <div class="imgBg">
                      <div class="qrCodeIMG" id="queryIdIMG" ref="queryIdIMG"></div>
                    </div>
                    <span class="tpl">手机扫码预览模板</span>
                  </div>
                  <div>
                    <el-button type="primary" size="medium" @click="nextStepKai(item)" style="width: 168px">下一步，设置活动内容</el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div> -->

        <!--  -->
        <div class="activeEdit_bottom" v-loading="loading">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in navList"
                :key="item.id"
                :class="{ activeTem: tabActive == index }"
                v-show="item.frontHide == 0"
                @click="handleNav(item, index)"
              >
                {{ item.groupName }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid rgba(123,97,255,0.15);"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(123, 97, 255, 0.05);"
                ></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width:100%;"
                    :src="item.imageUrl"
                    alt=""
                  />
                  <img
                    v-if="item.activityStartTime"
                    class="temImg_content_img_free"
                    src="@/assets/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div
                    v-if="item.activityStartTime"
                    class="temImg_content_img_time"
                  >
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG1"
                  ref="qrCodeIMG1"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <!-- 分页 -->
        <!-- <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageData.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          style="text-align: right;margin-top: 20px;"
        >
        </el-pagination> -->
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 0">
        <div class="card-point tipBg">
          <div class="card-rule">官方规则：</div>
          <template v-if="venderType">
            <div class="card-connet" v-if="orderCRM">
              <p>
                1、自营店铺需要搭配<span style="color:#7B61FF;">云短信CRM</span
                >使用,<span
                  style="color:#7B61FF;"
                  @click="handleCreate"
                  class="pointer"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
            <div class="card-connet" v-else>
              <p>
                1、云短信CRM：订购到期时间
                {{ orderCRMtime }}（自营店铺需要搭配<span
                  @click="handleCreate"
                  class="pointer"
                  style="color:#7B61FF;"
                  >云短信CRM</span
                >使用）。
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
          </template>
          <div class="card-connet" v-else>
            <p>1、订单完成后发放奖励。</p>
          </div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="120px"
        >
          <div class="newsInfo">基本信息</div>
          <template>
            <el-form-item label="活动名称:" required>
              <el-input
                v-model="ruleForm.activityName"
                maxlength="15"
                show-word-limit
                placeholder="请填入活动名称"
                style="width: 400px"
                :disabled="isStart"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <!-- <el-date-picker
                  v-model="activityTimeValue"
                  type="datetimerange"
                  class="rangeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  ref="timeBox"
                  @change="activityTimeChange"
                  style="width: 400px; font-size: 12px"
                  :picker-options="pickerOptionsValue"
                  :default-time="defaultTime"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="activityTimeValue = []"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                /> -->
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.activityStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValue"
                  :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                  :clearable="false"
                  :disabled="isStart"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.activityEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange"
                  @focus="orderFocus(1)"
                  :picker-options="pickerOptionsValueEnd"
                  :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                  :clearable="false"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime()"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天
                <span style="color: #7B61FF">{{ timeOut }}</span> 小时
                <el-tooltip
                  class="item"
                  effect="light"
                  content="活动有效期不可超过订购有效期"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
              <div class="act-tip" v-if="isShowEndTip">
                *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
              </div>
            </el-form-item>
            <el-form-item label="活动参与对象:" prop="partner">
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="isStart"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <!-- 去掉非会员的选项 -->
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="display:flex">
              <span>入会时间：</span>
              <el-checkbox v-model="ruleDto.isCheckOpenCardTime" :disabled="isStart">指定时间段</el-checkbox>
              <div class="my_select_time" style="margin-left:8px">
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1"  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2"
                  :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <i v-if="!isStart" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </div>
            <span style="color:red">注意：该条件对【非会员】身份不生效</span>
              <!-- <span class="memberTips">注：由于接口限制，未入会用户需先入会方可参与活动</span><br />
            <span v-if="localStepNum == 3">注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span> -->
            </el-form-item>

          <!-- 1.14迭代 plus会员限制 -->
          <el-form-item label="Plus会员身份:" required>
            <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="isStart">不限</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="isStart">Plus会员</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="isStart">非plus会员</el-radio>
            <div style="color:red">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。</div>
          </el-form-item>

            <el-form-item label="活动条件:">
              <el-checkbox v-model="ruleForm.condFollow" :disabled="isStart"
                >关注店铺后方可参与活动</el-checkbox
              ></el-form-item
            >
            <div class="newsInfo">预售规则</div>
            <el-form-item label="参与规则:" required>
              <span
                >下单支付定金即可参与活动（预售商品支付尾款且确认收货才可以获得奖励）</span
              >
              <div class="rule_box">
                <div class="rule_box_top">
                  所下订单需满足如下条件<br />
                  <!-- <span style="color:red;margin-left:10px" v-if="venderType"
                    >注意：由于接口原因，自营仅支持统计订单金额（即非实付金额）</span
                  > -->
                </div>

                <div class="rule_box_middle">
                  <el-form-item label="预售下单时间:" required>
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px"
                        default-time="00:00:00"
                        class="time1"
                        @change="orderChange"
                        @focus="orderFocus(2)"
                        :clearable="false"
                        :picker-options="pickerOrderStart"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px"
                        default-time="23:59:59"
                        class="time2"
                        @change="orderChange"
                        @focus="orderFocus(2)"
                        :clearable="false"
                        :picker-options="pickerOrderEnd"
                      >
                      </el-date-picker>
                      <i
                        v-if="!isStart"
                        class="el-icon-circle-close date_icon1"
                        @click="clearOrderTime()"
                      ></i>
                      <img
                        src="@/assets/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                    <div class="act-tip" v-if="isShowTip">
                      *提示：修改下单时间活动条件不会改变已参与用户的数据状态，修改仅适用于新用户参与活动的判定
                    </div>
                  </el-form-item>
                  <el-form-item label="订单金额:" required v-if="venderType">
                    大于等于
                    <el-input
                      v-model="ruleForm.orderStartPayment"
                      @input="ruleForm.orderStartPayment = setNumber($event, 1, true)" 
                      @change="changDays()"
                      style="width:140px"
                      placeholder="请输入"
                      :disabled="isStart"
                    ></el-input
                    >&nbsp; 元 &nbsp;
                    <!-- &nbsp; 元- &nbsp;
                    <el-input
                      v-model="ruleForm.orderEndPayment"
                      @input.native="checkputnPositive"
                      @change="changDays()"
                      style="width:140px"
                      placeholder="请输入"
                      :disabled="isStart"
                    ></el-input
                    >&nbsp; 元<br> -->
                    <span style="color:red;margin-left:0px" v-if="venderType"
                      >注意：由于接口原因，自营仅支持统计订单金额（即非实付金额）</span
                    >
                  </el-form-item>
                  <el-form-item label="商品件数:">
                    大于等于
                    <el-input
                      v-model="ruleForm.orderStartCount"
                      @input="ruleForm.orderStartCount = setNumber($event, 1, true)" 
                      @change="changDays()"
                      style="width:140px"
                      placeholder="请输入"
                      :disabled="isStart"
                    ></el-input
                    >&nbsp; 件 &nbsp;
                    <!-- &nbsp; 件- &nbsp;
                    <el-input
                      v-model="ruleForm.orderEndCount"
                      @input="ruleForm.orderEndCount = getNumberData(1, $event, 0, 1)"
                      @change="changDays()"
                      style="width:140px"
                      placeholder="请输入"
                      :disabled="isStart"
                    ></el-input
                    >&nbsp; 件 -->
                  </el-form-item>
                </div>
                <div class="rule_box_bottom zindexBox">
                  <el-form-item label="指定购买商品:" required>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="0"
                      :disabled="isStart"
                      >全部商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="1"
                      :disabled="isStart"
                      >指定商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="2"
                      :disabled="isStart"
                      >排除商品</el-radio
                    >
                    <el-button
                      class="zindexBox"
                      :disabled="ruleForm.filterType == 0 || isStart"
                      :style="{
                        width: itemListForFilter.length > 0 ? '110px' : '60px',
                      }"
                      @click="exposureProductsFiter"
                    >
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                    <span style="color:red;margin-left:10px"
                      >注：商品务必是预售商品，否则用户无法参与活动</span
                    >
                  </el-form-item>
                </div>
              </div>
              <!-- <span style="color:red;margin-left:10px" v-if="activityData.id == 28"
                >注：订单完成后发放奖励，整个活动期间每人只可参与1次解锁，抽奖次数可自定义</span
              > -->
            </el-form-item>
             <!-- 1.14迭代需求 -->
             <el-form-item
              label="订单抽奖规则:"
              v-if="this.activityData.id == 28"
              required
            >
              <div class="limit">
                <el-radio-group v-model="lsRadio" :disabled="activityData.isStart">
                <div style="display:flex;flex-direction:column">
                <el-radio :label="0"> 
                  活动期间仅可解锁1个订单，获得
                  <el-input
                  v-model.number="ruleForm.drawPerPersonNum"
                  placeholder="请输入..."
                  @input="ruleForm.drawPerPersonNum = getNumberData(1, $event, 0, 1)"
                  style="width: 70px;"
                  :disabled="activityData.isStart"
                ></el-input>
                次抽奖机会
              </el-radio>
                <el-radio style="margin-top:10px" :label="1"><span style="padding-left:5px">活动期间解锁1个订单可获得1次抽奖机会，可解锁多个订单</span></el-radio>
              </div>
              </el-radio-group>
                <!-- <p>
                  每人可抽奖次数
                  <el-input
                    v-model.number="ruleForm.drawPerPersonNum"
                    placeholder="请输入..."
                    @input="ruleForm.drawPerPersonNum = getNumberData(1, $event, 0, 1)"
                    style="width: 70px;"
                    :disabled="isStart"
                  ></el-input>
                  次
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="解锁订单成功获取的抽奖次数，活动期间，多个订单符合，只能使用其中1个订单解锁1次。"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-question"
                      style="margin-left:10px;cursor:pointer;color:#ccc;"
                    ></i>
                  </el-tooltip>
                </p> -->
              </div>
          </el-form-item>
          <!-- 1.14迭代需求 -->
          <el-form-item label="中奖限制:" v-if="this.activityData.id == 28">
            <p>
                活动期间每人<span class="c"></span>中奖不超过
                <el-input
                    v-model.number="ruleForm.winningNoMoreThanNum"
                    @input="ruleForm.winningNoMoreThanNum = getNumberData(1, $event, 0, 1)"
                    placeholder="不限制"
                    style="width: 70px"
                    :disabled="isStart"
                ></el-input>
                  次
                </p>
                <p class="desc" style="color:red">
                  注:此处是对中奖次数做限制，不填写，表示不限制
                </p>
          </el-form-item>

            <div class="newsInfo">奖品设置</div>
            <el-form-item
              label="奖品设置:"
              required
              v-if="this.activityData.id == 27"
            >
              <span
                >订单完成后发放奖励</span
              >
              <div class="prize_box">
                <el-table
                  :header-cell-style="{
                    'text-align': 'center',
                    'border-bottom': '2px solid #EBEEF5',
                    background: '#FAFAFA',
                  }"
                  :cell-style="{ 'text-align': 'center', overflow: 'visible' }"
                  :data="tableData"
                  border
                  style="width: 920px;overflow: visible;"
                >
                  <el-table-column label="选择奖品" width="110">
                    <template slot-scope="scope">
                      <span
                        @click="centerVis(scope)"
                        style="color:#7B61FF;cursor: pointer;"
                        >选择奖品</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="奖品类型" width="120">
                    <template slot-scope="scope">
                      <span style="color:#7F85E9;">{{
                        scope.row.prizeType | prizeType
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" width="110" label="值">
                  </el-table-column>
                  <el-table-column label="奖品名称" width="299">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.title"
                        maxlength="12"
                        :disabled="(scope.row.prizeType != 3||scope.row.isGoodManage) || isStart"
                        show-word-limit
                        style="width: 240px"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="145" label="奖品数量">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.prizeCount"
                        placeholder="请输入"
                        @input.native="
                          (e) =>
                            (scope.row.prizeCount = checkputn(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        @input="scope.row.prizeCount = getNumberData(1, $event, 0, 1),prizeNum(scope.row,0)"
                        @blur="beAdd(scope.row)"
                        :disabled="activityData.isStart && !scope.row.minNum || activityData.isStart"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                        totalAmountKey="prizeCount"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <span
                        v-if="scope.$index != 0 && !isStart"
                        class="s"
                        style="color:#7B61FF;cursor: pointer;"
                        @click="itemDel(scope.$index)"
                        >删除</span
                      >
                      <el-button type="text" v-if="isStart && scope.row.title"
                        @click="itemAddNum('tableData',scope.$index)">增加奖品数量</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  @click="addPrizeRule"
                  class="add_btn1"
                  style="width: 125px;"
                  v-if="!isStart"
                >
                  <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
                  添加奖项（{{ tableData.length }}/4）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否支持C端撤回奖品:" required label-width="180px">
             <el-radio-group v-model="ruleForm.supportRollback" :disabled="isStart">
              <el-radio :label="1">支持撤回</el-radio>
              <el-radio :label="0">不支持撤回</el-radio>
             </el-radio-group>
            </el-form-item>
            <el-form-item required v-if="this.activityData.id == 28">
              <div>
                订单完成后发放奖励
              </div>
              <span slot="label" class="set">奖品设置:</span>
              <div class="termAdd">
                <el-popover placement="right" width="270" trigger="hover">
                  <img src="@/assets/images/integralCenter/wzsyt.png" alt="" />
                  <span slot="reference">位置示意图</span>
                </el-popover>
                <p>
                  累计中奖率: <span class="add">{{ winningRate }} %</span>
                </p>
              </div>
              <el-table
                :data="prizeSettingList"
                style="width: 100%; border: 1px solid #f0f0f0"
                :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'left',
                }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column label="位置">
                  <template slot-scope="scope">
                    <span v-if="scope.$index == 0">一</span>
                    <span v-if="scope.$index == 1">二</span>
                    <span v-if="scope.$index == 2">三</span>
                    <span v-if="scope.$index == 3">四</span>
                    <span v-if="scope.$index == 4">五</span>
                    <span v-if="scope.$index == 5">六</span>
                    <span v-if="scope.$index == 6">七</span>
                    <span v-if="scope.$index == 7">八</span>
                  </template>
                </el-table-column>

                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <span
                      class="pointer"
                      style="color:#7B61FF"
                      @click="chooseVis(scope)"
                      >选奖品</span
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{getPrizeTypeName(scope.row.prizeType)}}</span>
                  </template>
                </el-table-column>

                <el-table-column label="值" width="80" prop="price">
                </el-table-column>

                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.title"
                      maxlength="12"
                      :disabled="(scope.row.prizeType != 3||scope.row.isGoodManage) || isStart"
                      show-word-limit
                      style="width: 240px"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="奖品总数" width="180">
                  <template slot="header">
                    <span>奖品总数</span>
                    <el-popover
                      placement="top-start"
                      offset="100"
                      trigger="hover"
                      content="奖品总量是控制奖品最多发放份数，达到设置数值后不再发放此奖品；"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.totalAmount"
                      @input.native="(e) =>(scope.row.totalAmount = checkputn(e,scope.row,'jindou'))"
                      placeholder="请输入..."
                      style="width: 70px"
                      @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1),prizeNum(scope.row,1)"
                      @blur="beAdd(scope.row)"
                      :disabled="activityData.isStart && !scope.row.minNum || activityData.isStart"
                    ></el-input>
                    份
                  </template>
                </el-table-column>

                <el-table-column label="每日发放限额" width="180">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.dailyLimit"
                      placeholder="请输入..."
                      style="width: 70px"
                      @input="scope.row.dailyLimit = checkLimit(scope.row,1)"
                      :disabled="!valueRow ? false : !scope.row.totalAmount ? true : false"
                    ></el-input>
                    份
                  </template>
                </el-table-column>

                <el-table-column label="中奖率" width="130px">
                  <template slot="header">
                    <span>中奖率</span>
                    <el-popover
                      placement="top-start"
                      width="480"
                      offset="100"
                      trigger="hover"
                      content="中奖总概率可设置区间为大于0%，小于等于100%。本软件中奖概率是按数学中的概率统计学来计算的，并非硬性指标。 比如概率为1%，并非100次抽奖有且只有1次中奖，也不是第100次抽奖才会中奖。 而是每一次抽奖的机率都是平等的，第一次抽是1%,第100次、1万次抽也是1%。 举个现实中抽奖的例子，抽奖箱中有100个球，其中1个是红球代表中奖，其它99个是白球代表不中奖，每一次只能从中抽取1个球， 抽完后再放入箱中，下一个人再来抽(即每次抽奖箱中都有100个球，保证每次抽奖的概率平等性)，这样有可能第1个抽奖的就抽中了红球，或有可能第100个抽奖的都没抽中，也或100个人抽了已经有3个抽中了红球都有可能，都是属于统计学的概率问题。"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.percentage"
                      placeholder="请输入..."
                      style="width: 90px"
                      @keyup.native="scope.row.percentage = oninput2(scope.row.percentage,scope.$index)"
                      :disabled="!valueRow ? false : !scope.row.totalAmount ? true : false"
                    ></el-input>
                    %
                  </template>
                </el-table-column>

                <el-table-column label="最多中奖次数" width="120px">
                  <template #header>
                    <el-tooltip
                      effect="light"
                      content="当单个用户中奖次数达到设定上限后，后续抽奖不再分配该奖品，系统自动重配其他奖品。"
                      placement="right"
                    >
                      <div>
                        最多中奖次数<i style="color: #ccc;" class="el-icon-question"></i>
                      </div>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.singleMaxWin"
                      @input="scope.row.singleMaxWin = getNumberData(1, $event, 1, 0, 9999)"
                      placeholder="请输入..."
                      style="width: 70px"
                      :disabled="!valueRow ? false : !scope.row.totalAmount ? true : activityData.isStart ? true : false"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="图片" width="170">
                  <template slot="header">
                    <span>图片</span>
                    <el-popover
                      placement="top-start"
                      width="400"
                      offset="100"
                      trigger="hover"
                      content="图片显示在抽奖页面的奖品展示区域，建议图片宽高为200px*200px图片必须为jpg和png格式，小于300KB;"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.logo"
                      :src="scope.row.logo"
                      style="width: 56px; height: 56px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <span
                      v-if="!isStart"
                      class="pointer"
                      style="color:#7B61FF"
                      @click="cleanData(scope.row)"
                      >清除</span
                    >
                    <el-button type="text" v-if="isStart && scope.row.title && scope.row.title != '谢谢参与'"
                      @click="itemAddNum('prizeSettingList',scope.$index)">增加奖品数量</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tips1 tipBg">
                <img src="@/assets/images/new_icon_reminder.png" />
                <span style="margin-left:21px"> 说明</span>
                <p>
                  1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
                </p>
                <p>
                  2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
                </p>
                <!-- <p>3、中奖率精确到小数点后三位，如不想中奖可设置0%</p> -->
                <p>
                  3、实物奖品可上传图片，不上传使用默认图片。
                </p>
                <p>
                  4、为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担；
                </p>
                <p>5、进行中的活动修改中奖概率有一定客诉风险，不建议频繁修改。</p>
              </div>
            </el-form-item>
            <orderShopInfo v-model="customerPaperwork"/>
            <div class="newsInfo">曝光商品</div>
            <el-form-item label="曝光商品:">
              <el-checkbox
                v-model="ruleForm.exposureSwitch"
                @change="exposureSwitchChange"
              >
                是否添加曝光商品
              </el-checkbox>
              <el-button
                style="width: 155px; margin: 0 15px;display: inline-block;"
                :class="[{ add_btn1: ruleForm.exposureSwitch },'zindexBox']"
                @click="exposureProducts"
                :disabled="ruleForm.exposureSwitch == false"
              >
                {{
                  itemListFor.length != ""
                    ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                    : "添加曝光商品"
                }}
              </el-button>
              <el-radio-group
                v-model="ruleForm.radio"
                :disabled="ruleForm.exposureSwitch == false"
              >
                <el-radio :label="0">显示京东价</el-radio>
                <!-- <el-radio :label="1">显示促销价</el-radio> -->
              </el-radio-group>
              <draggable
                v-if="itemListFor.length > 0"
                v-model="mainImagelist"
                chosen-class="chosen"
                :scroll="true"
                animation="150"
                force-fallback="true"
                @start="isDragging = true"
                @end="onEnd"
                style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
                filter=".unmover"
              >
                <transition-group type="transition">
                  <div
                    v-for="(item, index) in mainImagelist"
                    :key="item.skuId"
                    style="display: inline-block; position: relative"
                    class="show_upImg2"
                  >
                    <img
                      :src="item.logo"
                      width="120px"
                      height="120px"
                      style="display: inline-block"
                    />&nbsp;
                    <div class="delectPosible">
                      <span class="delectSort">拖动排序</span>
                      <img
                        src="@/assets/thdImg/pages/delet.svg"
                        @click.stop="delec(index)"
                        class="delectIcom"
                      />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
            <template>
              <div class="newsInfo">分享设置</div>
              <el-form-item label="小程序分享标题:" required label-width="125">
                <el-input
                    type="text"
                    style="width: 400px;margin-left:8px;"
                    show-word-limit
                    v-model="ruleForm.shareTitle"
                    :maxlength="28"
                    :disabled="isStart"
                  ></el-input>
              </el-form-item>
              <el-form-item label="小程序分享简介:" required label-width="125">
                <el-input
                    type="text"
                    style="width: 400px;margin-left:8px;"
                    show-word-limit
                    v-model="ruleForm.shareIntroduce"
                    :maxlength="28"
                    :disabled="isStart"
                  ></el-input>
              </el-form-item>
              <el-form-item label="小程序分享图片:" required label-width="130">
                <div class="miniAppPic" style="margin-left:16px;">
                  <div class="top">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUpload1"
                      :on-success="handleUpload1"
                      :disabled="isStart"
                      >
                      <el-button size="mideal" class="returnBtn">自定义上传</el-button>
                    </el-upload>
                    <span class="reset" @click="picUrlReset1">重置</span>
                  </div>
                  <div class="bottom">
                    <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-plus"></i>
                      </div>
                    </el-image>
                    <div class="tips11">
                      <p>建议上传尺寸：200px * 200px</p>
                      <p>图片大小：1MB以内</p>
                      <p>格式：jpg、png</p>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </template>
            <div class="newsInfo">活动规则</div>
            <el-form-item label="规则内容:" required>
              <div
                style="
              width: 570px;
              backgroundcolor: rgba(250, 250, 250, 1);
              padding: 8px;
              position: relative;
            "
              >
                <el-input
                  type="textarea"
                  class="textarea"
                  style="width: 543px"
                  resize="none"
                  v-model="ruleForm.activityRulesText"
                  :maxlength="2000"
                ></el-input>
                <div class="prosi" style="color: #909399">
                  （{{
                    ruleForm.activityRulesText.length
                      ? ruleForm.activityRulesText.length - 1
                      : 0
                  }}/2000）
                </div>
                <div>
                  <el-button
                    type="primary"
                    class="generate"
                    plain
                    @click="generateRule"
                  >
                    生成规则
                  </el-button>

                  <span class="desc">
                    <i class="el-alert__icon el-icon-info"></i>
                    提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                  </span>
                </div>
              </div>
            </el-form-item>
            <actInfoSetting :activityData="activityData" :valueRow="valueRow" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
          </template>

          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <el-button
        v-show="!itemId"
        class="returnBtn"
        size="medium"
        @click="clickLocalStep()"
      >
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存并完成设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button v-show="itemId" class="keepBtn" type="primary" size="medium"
        >保存并完成设置</el-button
      >
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      :isSupportVirtualGroup="true"
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      :typeDefault="typeDefault"
      :num="1"
      :actId="valueRow"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      @close="colseDialog"
      v-if="showDialog"
      ref="selectProduct"
      @choose-shop="getTheData"
      :outsideShow="!venderType"
    >
    </selectProduct>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      :typeDefault="typeDefault"
      :num="1"
      :actId="valueRow"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      @close="colseDialog"
      v-if="showDialog"
      ref="selectProduct1"
      @choose-shop="getTheData1"
      :outsideShow="!venderType"
    >
    </selectProduct>
    <!-- <img src="../../assets/images/new" /> -->
     <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
  </div>
</template>

<script>
import dailyLimitConfig from "@/components/dailyLimitConfig.vue";
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { updateCommon } from "@/api/integralCenter/integralTask";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
// import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import addPrizeNum from "./components/add-prize-num.vue";
import {
  hdTaskTemplateGroup,
  publicOpen,
  createPresell,
  editPresell,
  createlottery,
  getlottery,
  getPresell,
  sellerImage,
} from "@/api/paradiseAndTaskCommonController.js";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "京东E卡",
  "爱奇艺会员",
  "京东PLUS会员",
  "现金红包",
];
export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    addPrizeNum,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState(["venderType"]),
    winningRate() {
      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });
      return winningRate;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      }
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "14") {
        result = "实物（随单发）";
      }
      return result;
    },
  },
  data() {
    return {
      customerPaperwork: {},
      isKeyActivity: 0,
      placementPosition: [],
      actEndTime: "",
      orderStartTime: "",
      orderEndTime: "",
      isShowEndTip: false,
      isShowTip: false,
      includeArr: [],//指定商品
      excludeArr: [],//排除商品
      // 1.14迭代需求
      lsRadio:0,
      // 1.14迭代 指定入会时间
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },

      navList: [],
      tabActive: 0,
      navItem: {
        id: "-1",
      },
      templateId: 1, //模板类型
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.activityEndTime).valueOf()-24*60*60*1000;
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      giftPrizeType: [], // 礼包样式数量
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftID: "", // 礼包id
      giftList: [], // 礼包模板
      disableVF: true, // 人群禁用
      disableCUS: true, //  人群禁用
      dialogPrize: false, // 弹窗
      currtIndex: -3,
      libaoItem: {}, // 选中的item
      // 人群多选
      verCheckAll: false,
      starCheckAll: false,
      // dialogPrize: true,
      levelList: [],
      disableTime: false,
      clickActual: false,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
      ],
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() >
                new Date(this.ruleForm.activityEndTime).getTime() ||
              time.getTime() < Date.now() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })(),
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.orderStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.orderEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.orderEndTime).getTime()
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        // {
        //   continueSignPoints: "",
        //   days: "",
        // },
      ],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      activityStartTime: null,
      activityEndTime: null,
      ruleForm: {
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        // 复购 首单 下单
        condFollow: false, // 是否需要关注店铺
        days: "100", //近X天内未购
        orderStartTime: "", //下单开始时间
        orderEndTime: "", //下单结束时间
        orderStartCount: "", //订单开始笔数
        orderEndCount: "", //订单结束笔数
        orderStartPayment: "", //订单开始金额
        orderEndPayment: "", //订单结束金额
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        // 开卡  店铺
        modelIds: "", //活动对应的人群包id
        vermicelliVal: [], //活动对应的人群包多选
        starVal: [], //活动对应的人群包多选
        sendCount: "", //发送人数
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是
        drawPerPersonNum: "",
        winningNoMoreThanNum: "",
        isMemberGiftCheck: false,
        isHavePrizes: "2",
        prizes: [], // 礼包样式  积分  京豆等等
        itemList: [], //曝光商品集合
        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片
        supportRollback: 0, // 是否支持奖品撤回
      },
      sharePic: "",
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      orderCRM: false,
      orderCRMtime: "",
      pageData: {
        size: 10000,
        source: 4,
        current: 1,
        total: 0,
      },
      isStart: false,
      isDraft:false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
    };
  },
  async created() {
    this.isStart = this.activityData.isStart ? true : false
    // 数据初始化
    const { data } = await hdTaskTemplateGroup({
      hdTaskType: this.activityData.id,
    });
    console.log('当前玩法id',this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
    this.navList = [
      {
        id: -1,
        groupName: "全部",
        frontHide: false,
      },
      ...data,
    ];
    this.getPolite();

    const { message: res } = await publicOpen();
    if (res) {
      this.orderCRMtime = res;
      this.orderCRM = false;
    } else {
      if (this.venderType) {
        this.orderCRM = true;
      } else {
        this.orderCRM = false;
      }
      this.orderCRMtime = "";
    }

    if (this.activeValue) {
      this.activityData.id = this.activeValue;
      this.getEdit();
    }
    // 新增活动默认时间
    if(!this.valueRow){
      this.ruleForm.activityStartTime = this.$getDate(30)[0]
      this.ruleForm.activityEndTime = this.$getDate(30)[1]
      this.activityTimeChange();
    }
  },
  mounted() {
    this.getLevel();

    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    // console.log(this.activeValue, 99996);
  },
  methods: {
    // 京东计划数量计算
    prizeNum(row,type){
      if(type==1) {
        // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
        if([5,6,7,8,10].includes(Number(row.prizeType))){
          if(Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)){
            row.totalAmount = ""
            if(row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
            if(row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
            if(row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
            if(row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
            if(row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
          }
        }
      } else {
        if([5,6,7,8,10].includes(Number(row.prizeType))){
          if(Number(row.prizeCount) && (Number(row.prizeCount) > row.budgetRemain)){
            row.prizeCount = ""
            if(row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
            if(row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
            if(row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
            if(row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
            if(row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
          }
        }
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      if(toAddBelong == 'prizeSettingList'){
        this[toAddBelong][toAddIndex].totalAmount = num;
      }else {
        this[toAddBelong][toAddIndex].prizeCount = num;
      }
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      if(arrStr == 'prizeSettingList'){
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].totalAmount
        };
      }else {
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].prizeCount
        };
      }
      console.log(this[arrStr][index])
      if( !this.toAddItem.title ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    beAdd(row){
      console.log(row);
      if(this.isStart){
        if(this.activityData.id == 27){
          if(row.prizeCount < row.minNum && row.minNum){
            row.prizeCount = row.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        }
        if(this.activityData.id == 28){
          if(row.totalAmount < row.minNum && row.minNum){
            row.totalAmount = row.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res){
      if(res.code != 1){
        this.$message.error(res.messaga);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1(){
      if(this.activityData.isStart) return
      this.ruleForm.sharePic = this.sharePic
    },
    // 数据初始化
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.pageData.size = val;
      this.getPolite();
    },
    handleCurrentChange(val) {
      this.pageData.current = val;
      this.getPolite();
    },

    // 修改 数据回显
    getEdit() {
      if (this.activityData.id == 28) {
        getlottery(this.valueRow.id).then((res) => {
          // this.activityTimeValue = [
          //   String(res.data.startTime),
          //   String(res.data.endTime),
          // ];
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
          this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
          this.actEndTime = res.data.endTime;
          if(!this.activityData.isCopy) this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则foreach
          this.ruleForm.partner = res.data.allowLevel.split(",");

          // 1.14迭代需求
          this.lsRadio = res.data.orderLotteryActivityPartakeRule.winningCondition.drawNumType
          this.ruleForm.drawPerPersonNum = res.data.orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum;
          if(this.lsRadio == 1){
            this.ruleForm.drawPerPersonNum = ''
          }
          this.ruleDto = {
            isCheckOpenCardTime:res.data.orderLotteryActivityPartakeRule.isCheckOpenCardTime,
            openCardStartTime:res.data.orderLotteryActivityPartakeRule.openCardStartTime,
            openCardEndTime:res.data.orderLotteryActivityPartakeRule.openCardEndTime,
            plusObject:res.data.orderLotteryActivityPartakeRule.plusObject, //plus会员
          },
          // 1.14迭代需求 预售抽奖 这里回显
          this.lsRadio = res.data.orderLotteryActivityPartakeRule.winningCondition.drawNumType
          this.ruleForm.drawPerPersonNum = res.data.orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum;
          if(this.lsRadio == 1){
            this.ruleForm.drawPerPersonNum = ''
          }
          this.ruleForm.winningNoMoreThanNum = res.data.orderLotteryActivityPartakeRule.winningCondition.winningNoMoreThanNum;
          if (res.data.templateJson) {
            let obj = JSON.parse(res.data.templateJson);
            this.templateId = obj.id;
          }
          // 奖品
          this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;
          this.ruleForm.orderStartTime =
            res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderStartTime;
          this.ruleForm.orderEndTime =
            res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime;
          // 拷贝下单时间判断
          this.orderStartTime = res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderStartTime;
          this.orderEndTime = res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime;

          this.ruleForm.orderStartCount =
            res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderNumLower;
          this.ruleForm.orderEndCount =
            res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderNumUpper;
          this.ruleForm.orderStartPayment =
            res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderPriceLower;
          this.ruleForm.orderEndPayment =
            res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderPriceUpper;
          this.ruleForm.filterType = String(
            res.data.orderLotteryActivityPartakeRule.lotteryCondition
              .specifyGoods
          );
          // 店铺名称类型回显
          this.customerPaperwork = res.data.orderLotteryActivityPartakeRule.customerPaperwork ? JSON.parse(res.data.orderLotteryActivityPartakeRule.customerPaperwork) : {};
          this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
          // this.tableData = res.data.pointActivityPrizeDTOList;
          if(!this.activityData.isCopy){ 
            this.ruleForm.drawPerPersonNum = res.data.orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum;
            this.ruleForm.winningNoMoreThanNum = res.data.orderLotteryActivityPartakeRule.winningCondition.winningNoMoreThanNum;
            this.prizeSettingList = res.data.bigTurntableDrawPrizeDTOS;
            this.prizeSettingList.forEach(item=>{
              item.minNum=item.totalAmount
              item.isWrite = false
            })
          }
          
          // 指定购买商品
          if (
            res.data.orderLotteryActivityPartakeRule.lotteryCondition
              .specifyGoods == 1
          ) {
            this.itemListForFilter = res.data.jdSkuVOPage && res.data.jdSkuVOPage.records?res.data.jdSkuVOPage.records:[];
            this.includeArr = this.itemListForFilter;
            this.selectGoodsFilterArr = this.itemListForFilter;
          }
          if (
              res.data.orderLotteryActivityPartakeRule.lotteryCondition
                .specifyGoods == 2
            ) {
              this.itemListForFilter = res.data.jdSkuVOPage && res.data.jdSkuVOPage.records?res.data.jdSkuVOPage.records:[];
              this.excludeArr = this.itemListForFilter;
              this.selectGoodsFilterArr = this.itemListForFilter;
            } 
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.itemListFor = res.data.itemList;
          this.ruleForm.shareTitle = res.data.orderLotteryActivityPartakeRule.shareTitle;
          this.ruleForm.shareIntroduce = res.data.orderLotteryActivityPartakeRule.shareIntroduce;
          this.ruleForm.sharePic = res.data.orderLotteryActivityPartakeRule.sharePic;
          // 是否重点活动
          this.isKeyActivity = res.data.isKeyActivity || 0;
          this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
          this.activityTimeChange();
        });
      } else {
        getPresell(this.valueRow.id).then((res) => {
          // this.activityTimeValue = [
          //   String(res.data.startTime),
          //   String(res.data.endTime),
          // ];
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.activityStartTime = String(res.data.startTime);
          this.ruleForm.activityEndTime = String(res.data.endTime);
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.partner = res.data.allowLevel.split(",");
          // 1.14迭代需求 这里回显 指定入会时间
          this.ruleDto = {
            isCheckOpenCardTime:res.data.ruleDto.isCheckOpenCardTime,
            openCardStartTime:res.data.ruleDto.openCardStartTime,
            openCardEndTime:res.data.ruleDto.openCardEndTime,
            plusObject:res.data.ruleDto.plusObject, //plus会员
          }

          this.templateId = res.data.templateId;
          // 奖品
          this.ruleForm.condFollow =
            res.data.ruleDto.condFollow == 1 ? true : false;
          // this.templateUItype = res.data.templateJson ? JSON.parse(res.data.templateJson).templateUItype : 1;
          this.ruleForm.orderStartTime = res.data.ruleDto.orderStartTime;
          this.ruleForm.orderEndTime = res.data.ruleDto.orderEndTime;

          // 拷贝下单时间判断
          this.orderStartTime = res.data.ruleDto.orderStartTime;
          this.orderEndTime = res.data.ruleDto.orderEndTime;

          this.ruleForm.orderStartCount = res.data.ruleDto.orderStartCount;
          this.ruleForm.orderEndCount = res.data.ruleDto.orderEndCount;
          this.ruleForm.orderStartPayment = res.data.ruleDto.orderStartPayment;
          this.ruleForm.orderEndPayment = res.data.ruleDto.orderEndPayment;
          this.ruleForm.filterType = String(res.data.ruleDto.filterType);
          this.ruleForm.supportRollback = res.data.ruleDto.supportRollback;
          this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
          // 店铺名称类型回显
          this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {};
          // this.tableData = res.data.pointActivityPrizeDTOList;
          if(!this.activityData.isCopy){
            this.tableData = res.data.pointActivityPrizeDTOList.map(
              (item, index) => {
                let obj = {
                  ...item,
                  id: item.id,
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  logo: item.logo,
                  discount: item.price || item.singleAmount,
                  singleAmount: item.singleAmount,
                  price: item.price,
                  prizeCount: item.totalAmount,
                  minNum: item.totalAmount,
                };
                if (item.prizeType == 1) {
                  obj.quota = item.quota;
                  obj.couponType = item.couponType;
                }
                return obj;
              }
            );
          }

           // 指定购买商品
           if (res.data.ruleDto.filterType == 1) {
            this.itemListForFilter = res.data.ruleDto.itemList && res.data.ruleDto.itemList.length?res.data.ruleDto.itemList:[];
            this.selectGoodsFilterArr = this.itemListForFilter;
            this.includeArr = this.itemListForFilter;
            } else if(res.data.ruleDto.filterType == 2){
              this.itemListForFilter = res.data.ruleDto.itemList && res.data.ruleDto.itemList.length?res.data.ruleDto.itemList:[];
              this.selectGoodsFilterArr = this.itemListForFilter;
              this.excludeArr = this.itemListForFilter;
            }
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.itemListFor = res.data.itemList;
          this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
          this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
          this.ruleForm.sharePic = res.data.ruleDto.sharePic;
          this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
          this.activityTimeChange();
          if(this.activityData.isCopy){
            this.ruleForm.activityRulesText = ""
          }
        });
      }
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].secondImageUrl,
        });
      }
    },
    itemDel(index) {
      if (this.tableData.length == 1) {
        this.$message.warning("必须有一个奖项");
        return;
      }
      this.tableData.splice(index, 1);
    },
    addPrizeRule() {
      if (this.tableData.length === 4) {
        this.$message.warning("最多可设置4个奖项");
        return;
      }
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        discount: "",
        prizeCount: "",
        singleAmount: "",
      });
    },
    //选择商品数据 曝光
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.showDialog = false;
      if (prizeType == 1) {
        this.tableData[this.tableIndex].couponType = data.couponType;
        this.tableData[this.tableIndex].singleAmount = 1;
        this.tableData[this.tableIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
      }
      if (data.giftType) {
        this.tableData[this.tableIndex].giftType = Number(data.giftType);
      }
      this.tableData[this.tableIndex].price =
        data.discount || data.singleAmount;

      this.tableData[this.tableIndex].assetsId = Number(data.couponId);
      this.tableData[this.tableIndex].logo = data.logo;
      this.tableData[this.tableIndex].prizeType = prizeType;
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.tableData[this.tableIndex].skuId = data.skuId;
          delete this.tableData[this.tableIndex].isGoodManage
        } else {
          this.tableData[this.tableIndex].isGoodManage = data.isGoodManage;
        }
      }
      if (prizeType == 4) {
        this.tableData[this.tableIndex].title = data.discount + "店铺积分";
      } else {
        this.tableData[this.tableIndex].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.tableData[this.tableIndex].singleAmount = data.singleAmount;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
      }
    },
    //选择奖品
    getTheData1(data, prizeType) {
      console.log(data, prizeType, "选择奖品");
      this.showDialog = false;
      if (prizeType == 1) {
        this.prizeSettingList[this.tableIndex].couponType = data.couponType;
        this.prizeSettingList[this.tableIndex].singleAmount = 1;
        this.prizeSettingList[this.tableIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.tableIndex].quantityTotal =
          data.quantityTotal;
      }
      if (data.giftType) {
        this.prizeSettingList[this.tableIndex].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.tableIndex].price =
        data.discount || data.singleAmount;

      this.prizeSettingList[this.tableIndex].assetsId = Number(data.couponId);
      this.prizeSettingList[this.tableIndex].logo = data.logo;
      this.prizeSettingList[this.tableIndex].prizeType = prizeType;
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.prizeSettingList[this.tableIndex].skuId = data.skuId;
          delete this.prizeSettingList[this.tableIndex].isGoodManage
        } else {
          this.prizeSettingList[this.tableIndex].isGoodManage = data.isGoodManage;
        }
      }
      if (prizeType == 4) {
        this.prizeSettingList[this.tableIndex].title =
          data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.tableIndex].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.tableIndex].singleAmount = data.singleAmount;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.prizeSettingList[this.tableIndex].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.prizeSettingList[this.tableIndex].budgetRemain = data.budgetRemain;
      }
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //开卡礼包
    nextStepKai(items) {
      // console.log(items);
      //新增判断
      if (this.orderCRM) {
        return this.$message.warning(
          "自营店铺需要搭配云短信CRM使用！请联系客服！"
        );
      } else {
        this.templateId = items.id;
        this.localStepNum = this.activityData.id;
        this.localStep = 1;
        // this.templateUItype = items.templateUItype;
        this.$emit("titopName", this.activityData.name, true);
      }
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      if(this.isStart) return;
      this.itemArr = this.tableData
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      if (this.tableData[scope.$index].prizeType == 2) {
        this.clickActual = true;
      }
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    chooseVis(scope) {
      if(this.isStart) return;
      if(scope.row&&scope.row.prizeType == 14){
        this.$message({
          message: "该奖品类型不支持修改",
          type: "warning",
        });
        return
      }
      this.itemArr = this.prizeSettingList
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.totalAmount || "";
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct1.openDialog();
      });
    },
    // 保留小数点后两位
    oninput2(obj, i) {
      obj = obj.replace(/[^\d.]/g, ""); //清除除了“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d{1,5}).*$/, "$1$2.$3") //只能输入5个小数
      if (obj > 100) {
        obj = 100;
      }

      let value = obj * 1;
      this.prizeSettingList[i].percentage = value;
      let winningRate = 0;
      this.prizeSettingList.forEach((item,index) => {
        if(i==index) {
          item.isWrite = true
        }
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });
      if (winningRate > 100) {
        obj = 100 - (winningRate - value);
      } else if (winningRate == 100) {
        if (value >= 100) {
          obj = 100;
        } else {
          obj = 100 - (winningRate - value);
          if (value == 0) {
            obj = 0;
          }
        }
      }
      console.log(obj);
      return obj;
    },
    //清除
    cleanData(row) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleMaxWin = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.dailyLimit = null;
      // this.winningRate = 0;
      // this.prizeSettingList.forEach((item) => {
      //   if (item.percentage) {
      //     this.winningRate += Number(item.percentage);
      //   }
      // });
      // if (row.percentage) {
      //   this.winningRate = this.winningRate.toFixed(3);
      // }
    },

    //活动时间驱动
    activityTimeChange(val) {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiredIn
      ).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart = this.ruleForm.activityStartTime && this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd = this.ruleForm.activityEndTime && this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(Math.abs(new Date(this.ruleForm.activityEndTime)-new Date(this.ruleForm.activityStartTime)) / 1000 / 60 / 60 / 24);

        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 下单时间
    orderChange() {
      let start = new Date(this.ruleForm.orderStartTime).valueOf();
      let end = new Date(this.ruleForm.orderEndTime).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.orderStartTime &&
        this.ruleForm.orderStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.orderEndTime &&
        this.ruleForm.orderEndTime.substring(0, 10);
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 100) {
          this.$message.warning("下单时间最大范围为近100天");
          this.ruleForm.orderEndTime = null;
          return;
        }
      }
      if (start > end && start && end) {
        this.$message.warning("下单开始时间不能大于下单结束时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
    },
    orderFocus(type) {
      if(this.activityData.isStart) {
        if(type==1) {
          this.isShowEndTip = true
        } else {
          this.isShowTip = true
        }
      }
    },
    // 规则判断
    changDays() {
      if (
        this.ruleForm.orderStartCount &&
        this.ruleForm.orderEndCount &&
        Number(this.ruleForm.orderStartCount) >
          Number(this.ruleForm.orderEndCount)
      ) {
        this.$message.warning("商品结束件数要大于等于商品开始件数!");
        this.ruleForm.orderEndCount = "";
      }
      if (
        this.ruleForm.orderStartPayment &&
        this.ruleForm.orderEndPayment &&
        Number(this.ruleForm.orderStartPayment) >
          Number(this.ruleForm.orderEndPayment)
      ) {
        this.$message.warning("订单结束金额要大于等于订单开始金额!");
        this.ruleForm.orderEndPayment = "";
      }
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      // console.log(this.itemArrOne);
      this.joinBlackList = true;
      // this.$emit("saveEdit");
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        pointActivityPrizeDTOList: [], // 奖品
        integralParadisePrizeDTOS: [],
        ruleDTO: {
          // 1.14迭代需求 这里提交 指定入会时间
          isCheckOpenCardTime:this.ruleDto.isCheckOpenCardTime,
          openCardStartTime:this.ruleDto.openCardStartTime,
          openCardEndTime:this.ruleDto.openCardEndTime,
          plusObject:this.ruleDto.plusObject, //plus会员

          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        },
        orderLotteryActivityPartakeRule: {},
        itemList: this.itemListFor, //曝光商品集合
        templateId: this.templateId,
        isKeyActivity: this.isKeyActivity, // 是否重点活动
        placementPosition: this.placementPosition.join(","),
      };
      console.log(this.activityData.id,cardParams,'==========>>>>>');
      if (this.activityData.id == 27) {
        cardParams.ruleDTO = {
          // 1.14迭代需求 这里提交 指定入会时间
          isCheckOpenCardTime:this.ruleDto.isCheckOpenCardTime,
          openCardStartTime:this.ruleDto.openCardStartTime,
          openCardEndTime:this.ruleDto.openCardEndTime,
          plusObject:this.ruleDto.plusObject, //plus会员

          // subType: 27, //活动类型   17: 首单专享礼 18:复购有礼
          condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
          // days: this.ruleForm.days, //近X天内未购
          orderStartTime: this.ruleForm.orderStartTime,
          orderEndTime: this.ruleForm.orderEndTime,
          orderStartCount: this.ruleForm.orderStartCount,
          orderEndCount: this.ruleForm.orderEndCount,
          orderStartPayment: this.ruleForm.orderStartPayment,
          orderEndPayment: this.ruleForm.orderEndPayment,
          filterType: this.ruleForm.filterType,
          skuIdList: this.itemListForFilter.map((item) => item.skuId),
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          supportRollback: this.ruleForm.supportRollback,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        }; //活动名称
        console.log(this.tableData);
        cardParams.pointActivityPrizeDTOList = this.tableData.map((item) => {
          let prize = {
            ...item,
            totalAmount: item.prizeCount, // 总数额
          };
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
            prize.singleAmount = 1;
          } else if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
          }else if(prize.prizeType == 3){
            if(prize.isGoodManage==1) {
              prize.assetsId = item.assetsId;
            } else {
              prize.assetsId = item.skuId;
            }
           
          } else {
            prize.singleAmount = 1;
          }
          return prize;
        });
      } else {
        cardParams.orderLotteryActivityPartakeRule = {
          isCheckOpenCardTime:this.ruleDto.isCheckOpenCardTime,
          openCardStartTime:this.ruleDto.openCardStartTime,
          openCardEndTime:this.ruleDto.openCardEndTime,
          plusObject:this.ruleDto.plusObject, //plus会员

          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          lotteryCondition: {
            orderStartTime: this.ruleForm.orderStartTime,
            orderEndTime: this.ruleForm.orderEndTime,
            orderNumLower: this.ruleForm.orderStartCount,
            orderNumUpper: this.ruleForm.orderEndCount,
            orderPriceLower: this.ruleForm.orderStartPayment,
            orderPriceUpper: this.ruleForm.orderEndPayment,
            specifyGoods: this.ruleForm.filterType,
            skuIds: this.itemListForFilter.map((item) => item.skuId),
          },
          winningCondition: {
            // 1.14迭代 抽奖规则
            drawNumType: this.lsRadio,
            drawPerPersonNum: this.lsRadio==0?this.ruleForm.drawPerPersonNum:1,
            drawPerPersonNum: this.ruleForm.drawPerPersonNum,
            winningNoMoreThanNum: this.ruleForm.winningNoMoreThanNum,
          },
        };
        cardParams.integralParadisePrizeDTOS = this.prizeSettingList.map(
          (item) => {
            let prize = {
              ...item,
              percentage: item.percentage ? item.percentage : 0,
            };
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              prize.singleAmount = 1;
            } else if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            }else if(prize.prizeType == 3){
              prize.assetsId = item.skuId || item.assetsId;
            } else {
              prize.singleAmount = 1;
            }

            return prize;
          }
        );
      }

      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        cardParams.itemList = b;
      }

      if(!this.isDraft){
        //活动名称的限制
        if (
          !this.ruleForm.activityName ||
          this.ruleForm.activityName.length == 0
        ) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
          this.$message.warning("请输入活动时间");
          return;
        }

        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return
        }

        if (this.ruleForm.partner.length == 0) {
          this.$message.warning("活动参与对象不能为空");
          return;
        }
        if(this.ruleDto.isCheckOpenCardTime&&(!this.ruleDto.openCardStartTime||!this.ruleDto.openCardEndTime)){
          return this.$message.warning("请选择入会时间");
        }

        //下单时间不能为空
        if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
          this.$message.warning("请填写下单时间！");
          return;
        }
        //商品件数不能为空 1.14迭代取消限制
        // if (!this.ruleForm.orderStartCount) {
        //   this.$message.warning("请填写商品件数");
        //   return;
        // }
        //订单金额不能为空
        if (!this.ruleForm.orderStartPayment && this.venderType) {
          this.$message.warning("请填写订单金额");
          return;
        }
        //奖品设置最少一项
        if (this.tableData.length === 0) {
          this.$message.warning("奖品设置最少一项！");
          return;
        }
        if (this.ruleForm.filterType == 1) {
          if (this.itemListForFilter.length == 0) {
            this.$message.warning("请添加指定商品！");
            return;
          }
        } else if (this.ruleForm.filterType == 2) {
          if (this.itemListForFilter.length == 0) {
            this.$message.warning("请添加排除商品！");
            return;
          }
        }
        // 请将奖品填写完整！
        let isFlay = false;
        if (this.activityData.id == 27) {
          this.tableData.forEach((item) => {
            if (!item.price || !item.prizeCount) {
              isFlay = true;
            }
          });
        } else {
          this.prizeSettingList.forEach((item) => {
            if (item.prizeType != 9) {
              if (!item.totalAmount) {
                isFlay = true;
              }
            }
          });
        }
        if (isFlay) {
          return this.$message.warning("请将奖品填写完整！");
        }
        if(!this.useValidateMoreActSet(this)) {
          return;
        }
        //请添加曝光商品！
        if (this.ruleForm.exposureSwitch) {
          if (this.itemListFor.length === 0) {
            this.$message.warning("请添加曝光商品！");
            return;
          }
        }
        // 小程序分享标题
        if (!this.ruleForm.shareTitle) {
          this.$message.warning("请输入小程序分享标题");
          return;
        }
        // 小程序分享简介
        if (!this.ruleForm.shareIntroduce) {
          this.$message.warning("请输入小程序分享简介");
          return;
        }
        //活动规则不能为空
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }

        // 1.14迭代需求 这里验证
        if(this.activityData.id == 28&&this.lsRadio==0&&!this.ruleForm.drawPerPersonNum){
          this.$message.warning("请完善订单抽奖规则");
          return;
        }
        if(this.placementPosition.length==0) {
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
          if (this.activityData.id == 27) {
            let res;
            if(this.activityData.isStart){ // 进行中修改更换公共接口
              console.log(cardParams);
              let params = {
                activityId: this.valueRow.id,
                // endTime: cardParams.endTime,
                ruleDescription: cardParams.ruleDescription,
                prizes: cardParams.pointActivityPrizeDTOList.filter(item=>item.totalAmount).map(item=>{
                  return {
                    ...item,
                    prizeId: item.id,
                    totalAmount: item.totalAmount,
                    percentage: item.percentage,
                    singleMaxWin: item.singleMaxWin,
                  }
                }),
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                ruleDTO: cardParams.ruleDTO,
              }
              if(this.orderStartTime!=this.ruleForm.orderStartTime||this.orderEndTime!=this.ruleForm.orderEndTime) {
                params.ruleDTO = cardParams.ruleDTO
              }
              if(this.actEndTime!=this.ruleForm.activityEndTime) {
                params.endTime = this.ruleForm.activityEndTime
              }
              res = await updateCommon(params)  
            }else{
              res = await editPresell({...cardParams,pointActivityId: this.valueRow.id})
            }
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            } else {
              if(res.message){
                this.$message.error(res.message);
              }else{
                this.$message.error(res.data.message);
              }
            }
          } else {
            let res;
            if(this.activityData.isStart){
              console.log(cardParams);
              let params = {
                activityId: this.valueRow.id,
                // endTime: cardParams.endTime,
                ruleDescription: cardParams.ruleDescription,
                prizes: cardParams.integralParadisePrizeDTOS.filter(item=>item.totalAmount).map(item=>{
                  return {
                    ...item,
                    prizeId: item.id,
                    totalAmount: !item.isWrite ? item.totalAmount : undefined,
                    dailyLimit: item.dailyLimit,
                    percentage: item.percentage
                  }
                }),
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                ruleDTO: cardParams.ruleDTO,
              }
              if(this.orderStartTime!=this.ruleForm.orderStartTime||this.orderEndTime!=this.ruleForm.orderEndTime) {
                params.orderLotteryActivityPartakeRule = cardParams.orderLotteryActivityPartakeRule
              }
              if(this.actEndTime!=this.ruleForm.activityEndTime) {
                params.endTime = this.ruleForm.activityEndTime
              }
              res = await updateCommon(params)
            }else{
              res = await createlottery({...cardParams,id: this.valueRow.id})
            }
            if (res.code == 1) {
              this.$message.success(res.message);
              // this.$emit("saveEdit");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            } else {
              if(res.message){
                this.$message.error(res.message);
              }else{
                this.$message.error(res.data.message);
              }
            }
          }
        } else {
          if (this.activityData.id == 27) {
            if(this.isDraft){
              cardParams.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              cardParams.pointActivityPrizeDTOList = cardParams.pointActivityPrizeDTOList.filter(item=>item.prizeType)
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              cardParams.id = this.valueRow.id
            }
            if(this.activityData.isCopy){
              delete cardParams.id
            }
            createPresell(cardParams).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$message.success(res.message);
                  // this.$emit("saveEdit");
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                }
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            if(this.isDraft){
              cardParams.status = 5
            }
            if(this.isDraftEdit){
              cardParams.id = this.valueRow.id
            }
            createlottery(cardParams).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$message.success(res.message);
                  // this.$emit("saveEdit");
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "",
        text10 = "",
        text11 = "",
        text12 = "",
        text13 = "",
        text14 = "",
        text15 = "",
        text16 = "",
        text17 = "",
        text18 = "",
        text19 = "",
        test1 = "",
        test2 = "",
        test3 = "";
      //活动名称

      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text1 =
          "活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime;
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });
        text2 = "活动参与对象：" + levelText.splice(",");
      }

      //活动条件
      if (this.ruleForm.condFollow) {
        text3 = "活动条件：关注店铺后方可参与抽奖";
      }
      // 下单时间
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        test1 =
          "参与规则：下单时间：" +
          this.ruleForm.orderStartTime +
          "~" +
          this.ruleForm.orderEndTime;
      }
      // 订单笔数：
      if (this.ruleForm.orderStartCount && this.ruleForm.orderEndCount) {
        test3 =
          "；商品件数：" +
          this.ruleForm.orderStartCount +
          "件~" +
          this.ruleForm.orderEndCount +
          "件";
      } 
      if(this.ruleForm.orderStartCount && !this.ruleForm.orderEndCount) {
        test3 =
          "；商品件数：大于等于" +
          this.ruleForm.orderStartCount +
          "件"
      }
      if(!this.ruleForm.orderStartCount && !this.ruleForm.orderEndCount) {
        test3 =
          "；商品件数：不限"
      }
      // 订单金额：
      if (
        this.ruleForm.orderStartPayment &&
        this.ruleForm.orderEndPayment &&
        this.venderType
      ) {
        test2 =
          "；订单金额：" +
          this.ruleForm.orderStartPayment +
          "元~" +
          this.ruleForm.orderEndPayment +
          "元";
      }
      if(
        this.ruleForm.orderStartPayment &&
        !this.ruleForm.orderEndPayment &&
        this.venderType
      ) {
        test2 =
          "；订单金额：大于等于" +
          this.ruleForm.orderStartPayment +
          "元"
      }
      text4 = test1 + test2 + test3;
      text5 = `参与活动商品：${
        this.ruleForm.filterType == 1 ? "部分商品" : "全部商品"
      }`;
      // if (
      //   this.ruleForm.drawPerPersonNum ||
      //   this.ruleForm.winningNoMoreThanNum
      // ) {
      //   text6 = `抽奖机会：每人可抽奖${this.ruleForm.drawPerPersonNum}次，活动期间每人累计抽奖不超过${this.ruleForm.winningNoMoreThanNum}次`;
      // }
      if (this.lsRadio == 0 && this.ruleForm.drawPerPersonNum) {
        text6 = "抽奖机会：活动期间仅可解锁1个订单，获得" + this.ruleForm.drawPerPersonNum + "次抽奖机会";
      }
      if (this.lsRadio == 1) {
        text6 = "抽奖机会：活动期间解锁1个订单可获得1次抽奖机会，可解锁多个订单";
      }

      if(this.ruleForm.winningNoMoreThanNum){
        if(this.lsRadio == 0 && !this.ruleForm.drawPerPersonNum){
          text6 = `抽奖机会：活动期间每人累计抽奖不超过${this.ruleForm.winningNoMoreThanNum}次`
        }else{
          text6 = text6+'；'+`活动期间每人累计抽奖不超过${this.ruleForm.winningNoMoreThanNum}次`
        }
      }

      text8 =
        this.activityData.id == 27 ? `本次活动一个ID仅限参与一次本活动` : "";
      text9 = `满足下单需求的会员需及时填写赠品收货信息`;
      text10 = `满足条件参与领取后，待订单完成后，系统自动发放奖励`;
      text11 = `礼品数量有限，先到先得，有可能会有礼品擦肩而过情况`;
      text12 = `领取后不代表获得奖品，奖品以实际发放情况为准`;
      text13 = `因客户原因导致的恶意退款，取消赠品获取资格`;
      text14 = `虚拟奖品将在完成收货后24小时内自动发放`;
      text15 = `实物奖品需填写收货地址后联系商家进行发货`;
      text16 = `活动高峰期间订单校验会有所延迟，请耐心等待稍后再试`;
      text17 = `如果是实物奖项，请及时填写地址，否则将视为放弃机会`;
      // text18 = `实物奖品需填写收货地址后联系商家进行发货`;
      //奖品设置
      // this.tableData.forEach((item, index) => {
      //   let result = item.title + `${index + 1 == this.tableData.length ? "" : ";"}`;
      //   if (item.price && item.prizeCount) {
      //     text9 += `${index + 1}) ${result}`;
      //   }
      // });

      let plusText = ''
      // 1.14迭代 plus会员
      if(this.ruleDto.plusObject!=0){
        plusText =  `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}`;
      }else{
        plusText =  `Plus会员身份：不限`;
      }

      let Arr1 = [
        text1,
        text2,
        plusText,
        text3,
        text4,
        text5,
        text6,
        text7,
        text8,
        text9,
        text10,
        text11,
        text12,
        text13,
        text14,
        text15,
        text16,
        text17,
        text18,
        text19,
      ];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      // // 1.14迭代 plus会员
      // if(this.ruleDto.plusObject!=0){
      //   newText = newText + newNum + "." + `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}` + ";" + "\n";
      // }else{
      //   newText = newText + newNum + "." + `Plus会员身份：不限` + ";" + "\n";
      // }
      this.ruleForm.activityRulesText = newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    filterTypeChange(val) {
      if (val == "0") {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      } else if(val == "1"){
        this.selectGoodsFilterArr = this.includeArr
        this.itemListForFilter = this.includeArr
      } else if(val == "2"){
        this.selectGoodsFilterArr = this.excludeArr
        this.itemListForFilter = this.excludeArr
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        // this.mainImagelist = [];
      }
      // 根据类型显示商品
      if(this.ruleForm.filterType == "1"){
        this.selectGoodsFilterArr = this.includeArr
        this.itemListForFilter = this.includeArr
      }else if(this.ruleForm.filterType == "2"){
        this.selectGoodsFilterArr = this.excludeArr
        this.itemListForFilter = this.excludeArr
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },
    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(data) {
      if (data) {
        console.log(data);
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          // this.mainImagelist.push(fomeVaule);
        });
        if(this.ruleForm.filterType == 1){
          this.includeArr = this.itemListForFilter;
        }else if(this.ruleForm.filterType == 2){
          this.excludeArr = this.itemListForFilter
        }
        this.selectGoodsFilterArr = this.itemListForFilter;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        // row.prizeCount = row.prizeCount ? row.prizeCount : row.totalAmount;
        // console.log(row, 333333333333333);
        if (row.quantityTotal && row.price && row.prizeType == 2) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.prizeCount || row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.prizeCount || row.totalAmount;
        }
      }
    },
    checkLimit(row,min) {
      let newVal = (row.dailyLimit+ "").replace(/[^\d]/g, '')
      if(newVal) {
        if(newVal<min) {
          return ""
        }else {
          if(Number(row.dailyLimit) > Number(row.totalAmount)) {
            this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
            return ""
          } else {
            return Number(row.dailyLimit)
          }
        }
      }
    },
    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      // e.target.value = Number(filtered);
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },

    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    // 限免日期
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if(this.activityData.isCopy) return this.localStep = 0;
      this.localStep = 0;
      this.localStepNum = 0;
      this.ruleForm.radio = 0;
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = [];
      this.ruleForm.activityName = ""; //活动类型  13: 开卡礼包 14: 店铺礼包
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.selectGoodsStateFilter = false;
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.ruleForm.condFollow = false; // 是否需要关注店铺
      this.ruleForm.days = "100"; //近X天内未购
      this.ruleForm.orderStartTime = ""; //下单开始时间
      this.ruleForm.orderEndTime = ""; //下单结束时间
      this.ruleForm.orderStartCount = ""; //订单开始笔数
      this.ruleForm.orderEndCount = ""; //订单结束笔数
      this.ruleForm.orderStartPayment = ""; //订单开始金额
      this.ruleForm.orderEndPayment = ""; //订单结束金额
      this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      this.ruleForm.skuIdList = []; //skuId集合，多个，隔开
      this.tableData = [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ];
      this.mainImagelist = []; //图片拖拽排序
      this.isDragging = false;
      this.itemListFor = []; //商品弹框选择商品数据
      this.selectGoodsState = false; //曝光商品弹窗
      this.ruleForm.activityRulesText = "";
      this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.termAdd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  color: #333;
  p {
    margin: 0;
  }
  .add {
    margin-left: 4px;
    color: #7b61ff;
  }
}
.navTab {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  margin-bottom: 10px;
  span {
    height: 50px;
    line-height: 50px;
    position: relative;
    padding: 0 11px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #7b61ff;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80%;
      height: 2px;
      background-color: #7b61ff;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.memberTips {
  color: red;
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}


/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #7b61ff;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 860px;
  // height: 217px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        margin-left: 8px;
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.active-width {
  width: 1300px;
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #7b61ff;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #7b61ff;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}

.tips1 {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 13px 30px;
  background: #fffaee;
  font-size: 13px;
  color: #333;
  img {
    display: inline-block;
    float: left;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 9px 4px 0 3px;
  }
  i {
    color: #fe8f8a;
    opacity: 0.7;
  }
  p {
    margin: 0;
    line-height: 20px;
    padding-left: 18px;
  }
}

.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .add_btn1 {
    cursor: pointer;
    color: #7b61ff;
    border: 1px solid #7b61ff;
    width: 90px;
    background: rgba(123, 97, 255, 0.1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  // margin-top: 20px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 25px;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #7b61ff;
                border-bottom: 1px solid #7b61ff;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #7b61ff;
                border-left: 1px solid #7b61ff;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 40px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #7b61ff;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
.miniAppPic{
  position: relative;
  .image-slot{
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i{
      font-size: 30px;
      color: #909399;
    }
  }
  .top{
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn{
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:#7B61FF;
      background: rgba(123,97,255,0.1);
      border: 1px solid #7B61FF;
      &:hover{
        color: #fff;
        background: #7B61FF;
      }
    }
    .reset{
      color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom{
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg{
      width: 120px; 
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips11{
      position: absolute;
      left: 135px;
      top: 22px;
      line-height:2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
</style>

<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  //   .el-step__line {
  //     background-color: #7B61FF;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  // }
  // .el-step__title.is-process {
  //   color: #7B61FF;
  // }
  // .el-step__title.is-success {
  //   color: #7B61FF;
  // }
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}

</style>
